module.exports = __webpack_public_path__ + "static/laptop.19dcf14a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/laptop.png
// module id = 1701
// module chunks = 35783957827783